import AppWrapper from "./AppWrapper";
import { apiClient } from "@/api";
import React from "react";
import ReactDOM from "react-dom/client";
import { RecoilRoot } from "recoil";

import "./index.css";

import { i18nSetupLocalization } from "./i18n";
import { GenAiContext } from "./client/context";

i18nSetupLocalization();

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <GenAiContext.Provider value={apiClient}>
      <RecoilRoot>
        <AppWrapper />
      </RecoilRoot>

    </GenAiContext.Provider>
  </React.StrictMode>
);
